import { connect } from 'react-redux';
import { createActionSetQueueModalIsOpen } from '../../frontend/scripts/actions/queueModalActions';
import { TQueueModalState } from '../../frontend/scripts/reducers/queueModalReducer';
import { TApplicationState } from '../../frontend/scripts/libs/store';

type TPropsFromState = {
  queueModal: TQueueModalState;
};

type TPropsThatDispatch = {
  showQueueModal: () => void;
};

// take state from store and convert into props
function mapStateToProps(state: TApplicationState): TPropsFromState {
  return {
    queueModal: state.queueModal
  };
}

// return props that need access to `dispatch` function (props that can modify the store?)
function mapDispatchToProps(dispatch: Function, ownProps: any): TPropsThatDispatch {
  return {
    showQueueModal: () => {
      dispatch(createActionSetQueueModalIsOpen(true));
    }
  };
}

// HOC to return the wrapped component with access to the Queue Modal functions/state
export default function withQueueModal(WrappedComponent: any, pick?: string[]) {
  return connect<TPropsFromState, TPropsThatDispatch, any>(mapStateToProps, mapDispatchToProps)(WrappedComponent);
}
